import { useEffect, useState } from 'react';
import {
  addEventListener,
  removeEventListener,
} from 'common/js/media_query_event_polyfill';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => {
      setMatches(media.matches);
    };

    addEventListener(media, listener);

    return () => removeEventListener(media, listener);
  }, [matches, query]);

  return matches;
}
